import React from 'react';
const VideoElement = () => <div className="builder-video" style={{padding:'1rem',border:'1px dashed #ccc'}}>📹 Video (Coming Soon)</div>;
export default VideoElement;
